import React, { Component } from "react";
// import { BrowserRouter as BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import {BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "leaflet/dist/leaflet.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from "./App";
import AboutNRSC from "./AboutNRSC";
import AboutNHP from "./AboutNHP";
import AboutPortal from "./AboutPortal"
// import Alert from 'react-s-alert';
// import 'react-s-alert/dist/s-alert-css-effects/flip.css';
// import Popup from 'react-popup';

import ProjectOrganizationChart from "./ProjectOrganizationChart";
// import ProjectManagementUnit from "./ProjectManagementUnit"
import ProjManagementContent from "./ProjManagement";
import ProjImplment from "./ProjImplement";
import ResearchScientist from "./ResearchScientist";
import ResearchFellows from "./ResearchFellows";
import Home from "./HomeNew";
// import Meetings from "./Meetings"
// // import Test from "./Test"
// import Training from "./Training"
import Login from "./Login";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";

import Register from "./Register";
import Profile from "./Profile";
import ForgotPassword from "./ForgotPassword";
import EditProfile from "./EditProfile";
// import AdminProfile from './AdminProfile'
import NHPDataDownload from './NHPDataDownload'
import DataLayout from './DataDownloadLayout'
import AddTrainingPhotoGallery from "./web_training/Components/training_admin/components/AddPhotoGalleryById";
import NHPCASLogin from './NHPCASLogin'
// Flood routes
import FLLayout from "./web_flood/Components/HomeLayout";
import FLHome from "./web_flood/Components/Home";
import FLTechnical from "./web_flood/Components/FLTechnicalProposal";
import FLFinancialProposal from "./web_flood/Components/FLFinancialProposal";
import FLProjTeam from "./web_flood/Components/FLProjTeam";
import FLProjObjective from "./web_flood/Components/FLProjObjective";
import FLMap from "./web_flood/Components/MapContainerV3";

/* ET Routes */
import ETLayout from "./web_et/Components/HomeLayout";
import ETLayoutFlux from "./web_et/Components/HomeLayoutFlux";
import ETHome from "./web_et/Components/Home";
import ETTechnical from "./web_et/Components/ETTechnicalProposal";
import ETProjTeam from "./web_et/Components/ETProjTeam";
import ETProjObjective from "./web_et/Components/ETProjObjective";
import ETMap from "./web_et/Components/MapContainerV2";
import ETMapFlux from "./web_et/Components/MapContainerFluxV2";
//import ETMapFlux from "./web_et/Components/MapContainerV2Flux_bkp";
import ETFinancialProposal from "./web_et/Components/ETFinancialProposal";
// GLOF routes

import GLOFLayout from "./web_glacial/Components/HomeLayout";
import GLOFHome from "./web_glacial/Components/Home";
import GLOFTechnical from "./web_glacial/Components/GTechnical";
import GLOFProjTeam from "./web_glacial/Components/GProjTeam";
import GLOFProjObjective from "./web_glacial/Components/GProjObjective";
import GLOFFinancialProposal from "./web_glacial/Components/GFinancialProposal";
import GLOFMap from "./web_glacial/Components/GMapContainer";

// snow routes

import SnowLayout from "./web_snow/Components/HomeLayout";
import SnowHome from "./web_snow/Components/Home";
import SnowTechnical from "./web_snow/Components/STechnical";
import SnowProjTeam from "./web_snow/Components/SProjTeam";
import SnowProjObjective from "./web_snow/Components/SProjObjective";
import SnowFinancialProposal from "./web_snow/Components/SFinancialProposal";
import SnowMap from "./web_snow/Components/MapContainerV3";

// VIC routes
import VICLayout from "./web_vic/Components/HomeLayout";
import VICHome from "./web_vic/Components/Home";
import VICTechnical from "./web_vic/Components/VICTechnical";
import VICProjTeam from "./web_vic/Components/VICProjTeam";
import VICProjObjective from "./web_vic/Components/VICProjObjective";
import VICFinancialProposal from "./web_vic/Components/VICFinancialProposal";
import VICMap from "./web_vic/Components/MapContainerV2";
import InformationOverlay from "./web_vic/Components/InformationOverlay";
import VICMapSoil from "./web_vic/Components/MapContainerSoilV2";
import VICLayoutSoil from "./web_vic/Components/HomeLayoutSoil";

// drought routes

import HDLayout from "./web_hd/Components/HomeLayout";
import HDHome from "./web_hd/Components/Home";
import HDTechnical from "./web_hd/Components/HDTechnical";
import HDProjTeam from "./web_hd/Components/HDProjTeam";
import HDProjObjective from "./web_hd/Components/HDProjObjective";
import HDFinancialProposal from "./web_hd/Components/HDFinancialProposal";
import HDMap from "./web_hd/Components/MapContainerV2";

// // irrigation routes

// import IrrLayout from "./web_irrigation/Components/HomeLayout";
// import IrrHome from "./web_irrigation/Components/Home";
// import IrrTechnical from "./web_irrigation/Components/IRTechnicalProposal";
// import IrrProjTeam from "./web_irrigation/Components/IRProjTeam";
// import IrrProjObjective from "./web_irrigation/Components/IRProjObjective";
// import IrrFinancialProposal from "./web_irrigation/Components/IRFinancialProposal";
// import IrrMap from "./web_irrigation/Components/MapContainerV2";



// // irrigation routes

// import IrrLayout from "./web_irrigation/Components/HomeLayout";
// import IrrHome from "./web_irrigation/Components/Home";
// import IrrTechnical from "./web_irrigation/Components/IRTechnicalProposal";
// import IrrProjTeam from "./web_irrigation/Components/IRProjTeam";
// import IrrProjObjective from "./web_irrigation/Components/IRProjObjective";
// import IrrFinancialProposal from "./web_irrigation/Components/IRFinancialProposal";
// import IrrMap from "./web_irrigation/Components/MapContainerV2";

// irrigation routes

import IrrLayout from "./web_irrigation_new/Components/HomeLayout";
import IrrHome from "./web_irrigation_new/Components/Home";
import IrrTechnical from "./web_irrigation_new/Components/IRTechnicalProposal";
import IrrProjTeam from "./web_irrigation_new/Components/IRProjTeam";
import IrrProjObjective from "./web_irrigation_new/Components/IRProjObjective";
import IrrFinancialProposal from "./web_irrigation_new/Components/IRFinancialProposal";
import IrrMap from "./web_irrigation_new/Components/MapContainerV2";

// Training Routes

import TrainingLayout from "./web_training/Components/HomeLayout";
import TrainingNew from "./web_training/Components/Home";
import TRProjObjective from "./web_training/Components/TRProjObjective";
import TRProjTeam from "./web_training/Components/TRProjTeam";
import TRFinancialProposal from "./web_training/Components/TRFinancialProposal";
import TRTechnicalProposal from "./web_training/Components/TRTechnicalProposal";
// import ViewPhotoGallery from "./web_training/Components/ViewPhotoGallery";
import AllCourses from "./AllCourses";
import ScheduleByCourseId from "./ScheduleByCourseId";
import TraineeDetailsById from "./TraineeDetailsById";
import ViewPresentations from "./ViewPresentations";

//Training Admin Routes
import TRAdminLayout from "./web_training/Components/training_admin/TRAdminLayout";
import TrainingAdminHome from "./web_training/Components/training_admin/components/LandingPage";
import AddParticipant from "./web_training/Components/training_admin/components/AddTrainee";
import EditParticipant from "./web_training/Components/training_admin/components/EditParticipant";
import AddSession from "./web_training/Components/training_admin/components/AddSession";
import Sessions from "./web_training/Components/training_admin/components/Sessions";
import EditSession from "./web_training/Components/training_admin/components/EditSession";
import AddCourse from "./web_training/Components/training_admin/components/AddCourse";
import Courses from "./web_training/Components/training_admin/components/Courses";
import EditCourse from "./web_training/Components/training_admin/components/EditCourse";
import ScheduleByCourseIdEdit from "./web_training/Components/training_admin/components/ScheduleByCourseId";
import TraineeDetailsEditById from "./web_training/Components/training_admin/components/TraineeDetailsById";
import AddSchduleById from "./web_training/Components/training_admin/components/AddScheduleById";
import AddTraineeById from "./web_training/Components/training_admin/components/AddTraineeById";
import AddTimings from "./web_training/Components/training_admin/components/AddTimings";
import ModifyTrainee from "./web_training/Components/training_admin/components/ModifyTrainee";
import ModifySchedule from "./web_training/Components/training_admin/components/ModifySchedule";
import AddSchedule from "./web_training/Components/training_admin/components/AddSchedule";
import OverallFeedbackReport from "./web_training/Components/training_admin/components/OverallFeedbackReport";
import SessionWiseFeedbackReport from "./web_training/Components/training_admin/components/SessionWiseFeedbackReport";
import OverallReport from "./web_training/Components/training_admin/components/OverallReport";
import SessionReport from "./web_training/Components/training_admin/components/SessionReport";
import SessionFeedbackByCourseId from "./web_training/Components/training_admin/components/SessionFeedbackByCourseId";
import AddPresentations from "./web_training/Components/training_admin/components/AddPresentations";
import AddPresentationsBySessionId from "./web_training/Components/training_admin/components/AddPresentationsBySessionId";
import ConsolidatedSessionFeedback from "./web_training/Components/training_admin/components/ConsolidatedSessionFeedback";

// Training Feedback Routes

import TrainingFeedbackHome from "./web_training/Components/trainig_feedback/components/HomePage";
import TraineeLogin from "./TraineeLogin";
import FProtectedRoute from "./FeedbackProtectedRoute";
import TraineeForgotPassword from "./TraineeForgotPassword";
import FeedbackLayout from "./web_training/Components/trainig_feedback/components/HNavbar";
import CourseWiseFeedback from "./web_training/Components/trainig_feedback/components/Feedback/CourseWiseFeedback";
import OverallFeedback from "./web_training/Components/trainig_feedback/components/Feedback/OverallFeedback";
import SessionWiseFeedback from "./web_training/Components/trainig_feedback/components/Feedback/SessionWiseFeedback";

/** @AppRoute Component ---- Common Component for  Layout  */
const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout>
        <Component {...props} />
      </Layout>
    )}
  />
);

/** Router Main Component */

class Router extends Component {
  render() {
    return (
      <BrowserRouter basename="/nhp">
       {/* <BrowserRouter basename="/nhpirr">  */}
        <AuthProvider>
          {/* <Home/> */}
          <Switch>

            <AppRoute exact path="/" component={Home} layout={App} />

            <AppRoute path="/about-nrsc" component={AboutNRSC} layout={App} />

            <AppRoute path="/about-nhp" component={AboutNHP} layout={App} />
            <AppRoute path="/about-portal" component={AboutPortal} layout={App} />


            <AppRoute
              path="/proj-org-chart"
              component={ProjectOrganizationChart}
              layout={App}
            />
            <AppRoute
              path="/pm"
              component={ProjManagementContent}
              layout={App}
            />
            <AppRoute path="/pi" component={ProjImplment} layout={App} />
            <AppRoute path="/rs" component={ResearchScientist} layout={App} />
            <AppRoute path="/rf" component={ResearchFellows} layout={App} />
            {/* <AppRoute path="/meeting" component={Meetings} layout={App}/>
            <AppRoute path="/training" component={Training} layout={App}/> */}

            <AppRoute path="/login" component={Login} layout={App} />

            {/* <AppRoute path="/test" component={Test} layout={App}/> */}
            <AppRoute path="/register" component={Register} layout={App} />
            <AppRoute
              path="/forgot-password"
              component={ForgotPassword}
              layout={App}
            />
            <ProtectedRoute
              secret="PD"
              path="/upload-photogallery"
              component={AddTrainingPhotoGallery}
              layout={App}
            />

            {/* FLOOD portal routes  */}

            <AppRoute
              path="/webgis-flood"
              exact
              component={FLHome}
              layout={FLLayout}
            />
            <AppRoute
              path="/webgis-flood/tech-prop"
              component={FLTechnical}
              layout={FLLayout}
            />
            <AppRoute
              path="/webgis-flood/proj-team"
              component={FLProjTeam}
              layout={FLLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/webgis-flood/fin-prop"
              component={FLFinancialProposal}
              layout={FLLayout}
            />
            <AppRoute
              path="/webgis-flood/proj-obj"
              component={FLProjObjective}
              layout={FLLayout}
            />
            <AppRoute
              path="/webgis-flood/map"
              component={FLMap}
              layout={FLLayout}
            />
            {/* ET portal routes  */}
            <AppRoute
              path="/webgis-et"
              exact
              component={ETHome}
              layout={ETLayout}
            />
            <AppRoute
              path="/webgis-et/tech-prop"
              component={ETTechnical}
              layout={ETLayout}
            />
            <AppRoute
              path="/webgis-et/proj-team"
              component={ETProjTeam}
              layout={ETLayout}
            />
            <AppRoute
              path="/webgis-et/proj-obj"
              component={ETProjObjective}
              layout={ETLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/webgis-et/fin-prop"
              component={ETFinancialProposal}
              layout={ETLayout}
            />
            <AppRoute
              path="/webgis-et/map"
              component={ETMap}
              layout={ETLayout}
            />
            {/* VIC portal routes  */}
            <AppRoute
              path="/webgis-vic"
              exact
              component={VICHome}
              layout={VICLayout}
            />
            <AppRoute
              path="/webgis-vic/tech-prop"
              component={VICTechnical}
              layout={VICLayout}
            />
            <AppRoute
              path="/webgis-vic/proj-team"
              component={VICProjTeam}
              layout={VICLayout}
            />
            <AppRoute
              path="/webgis-vic/proj-obj"
              component={VICProjObjective}
              layout={VICLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/webgis-vic/fin-prop"
              component={VICFinancialProposal}
              layout={VICLayout}
              
            />
            <AppRoute
              path="/nhp-data-download"
              exact
              component={NHPDataDownload}
              layout={App}
            />
             <AppRoute
              path="/et-flux-dashboard"
              component={ETMapFlux}
              layout={ETLayoutFlux}
            />
             <AppRoute
              path="/vic-soil-moisture-dashboard"
              component={VICMapSoil}
              layout={VICLayoutSoil}
            />
            <AppRoute
              path="/nhp-data-login"
              exact
              component={NHPCASLogin}
              //render={()=>window.location="https://bhuvan-cas1.nrsc.gov.in/cas/login?service=https%3A%2F%2Fbhuvan-app1.nrsc.gov.in%2Fbhuvan2d%2Fbhuvan%2Flogin.php"}
              layout={DataLayout}
            />
            <AppRoute
              path="/webgis-vic/map"
              exact
              component={VICMap}
              layout={VICLayout}
            />
            <AppRoute
              path="/webgis-vic/map/hydrological-science"
              component={InformationOverlay}
              layout={VICLayout}
            />

            {/* Drought portal routes  */}
            <AppRoute
              path="/webgis-drought"
              exact
              component={HDHome}
              layout={HDLayout}
            />
            <AppRoute
              path="/webgis-drought/tech-prop"
              component={HDTechnical}
              layout={HDLayout}
            />
            <AppRoute
              path="/webgis-drought/proj-team"
              component={HDProjTeam}
              layout={HDLayout}
            />
            <AppRoute
              path="/webgis-drought/proj-obj"
              component={HDProjObjective}
              layout={HDLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/webgis-drought/fin-prop"
              component={HDFinancialProposal}
              layout={HDLayout}
            />
            <AppRoute
              path="/webgis-drought/map"
              component={HDMap}
              layout={HDLayout}
            />
            {/* Snowmelt portal routes  */}
            <AppRoute
              path="/webgis-snow"
              exact
              component={SnowHome}
              layout={SnowLayout}
            />
            <AppRoute
              path="/webgis-snow/tech-prop"
              component={SnowTechnical}
              layout={SnowLayout}
            />
            <AppRoute
              path="/webgis-snow/proj-team"
              component={SnowProjTeam}
              layout={SnowLayout}
            />
            <AppRoute
              path="/webgis-snow/proj-obj"
              component={SnowProjObjective}
              layout={SnowLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/webgis-snow/fin-prop"
              component={SnowFinancialProposal}
              layout={SnowLayout}
            />
            <AppRoute
              path="/webgis-snow/map"
              component={SnowMap}
              layout={SnowLayout}
            />

            {/* GLOF portal Routes    */}
            <AppRoute
              path="/webgis-glacials"
              exact
              component={GLOFHome}
              layout={GLOFLayout}
            />
            <AppRoute
              path="/webgis-glacials/tech-prop"
              component={GLOFTechnical}
              layout={GLOFLayout}
            />
            <AppRoute
              path="/webgis-glacials/proj-team"
              component={GLOFProjTeam}
              layout={GLOFLayout}
            />
            <AppRoute
              path="/webgis-glacials/proj-obj"
              component={GLOFProjObjective}
              layout={GLOFLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/webgis-glacials/fin-prop"
              component={GLOFFinancialProposal}
              layout={GLOFLayout}
            />
            <AppRoute
              path="/webgis-glacials/map"
              component={GLOFMap}
              layout={GLOFLayout}
            />

            {/* Irrigation portal routes  */}
            <AppRoute
              path="/webgis-irrigation"
              exact
              component={IrrHome}
              layout={IrrLayout}
            />
            <AppRoute
              path="/webgis-irrigation/tech-prop"
              component={IrrTechnical}
              layout={IrrLayout}
            />
            <AppRoute
              path="/webgis-irrigation/proj-team"
              component={IrrProjTeam}
              layout={IrrLayout}
            />
            <AppRoute
              path="/webgis-irrigation/proj-obj"
              component={IrrProjObjective}
              layout={IrrLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/webgis-irrigation/fin-prop"
              component={IrrFinancialProposal}
              layout={IrrLayout}
            />
            <AppRoute
              path="/webgis-irrigation/map"
              component={IrrMap}
              layout={IrrLayout}
            />

            {/* Training Basic Routes  */}
            <AppRoute
              path="/trainingnew"
              exact
              component={TrainingNew}
              layout={TrainingLayout}
            />
            <AppRoute
              path="/trainingnew/proj-obj"
              component={TRProjObjective}
              layout={TrainingLayout}
            />
            <AppRoute
              path="/trainingnew/tech-prop"
              component={TRTechnicalProposal}
              layout={TrainingLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/trainingnew/fin-prop"
              component={TRFinancialProposal}
              layout={TrainingLayout}
            />
            <AppRoute
              path="/trainingnew/proj-team"
              component={TRProjTeam}
              layout={TrainingLayout}
            />
            <AppRoute
              path="/trainingnew/courses"
              component={AllCourses}
              layout={TrainingLayout}
            />
            <AppRoute
              path="/trainingnew/view-schedules/:id"
              component={ScheduleByCourseId}
              layout={TrainingLayout}
            />
            <AppRoute
              path="/trainingnew/view-trainees/:id"
              component={TraineeDetailsById}
              layout={TrainingLayout}
            />
            <AppRoute
              path="/trainingnew/view-presentations/:id"
              component={ViewPresentations}
              layout={TrainingLayout}
            />
            {/* <AppRoute
              path="/trainingnew/photo-gallery"
              component={ViewPhotoGallery}
              layout={TrainingLayout}
            /> */}

            {/* /* Training Admin Routes */}

            <ProtectedRoute
              secret="PD"
              path="/trainingnew/training-admin"
              component={TrainingAdminHome}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/trainingnew/view-trainees_main/:id"
              component={TraineeDetailsById}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/add-participant"
              component={AddParticipant}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/add-trainee/:id"
              component={AddTraineeById}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/view-trainees_edit/:id"
              component={TraineeDetailsEditById}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/view-schedules/:id"
              component={ScheduleByCourseIdEdit}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/edit-participant/:id"
              component={EditParticipant}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/add-session"
              component={AddSession}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/add-schedule/:id"
              component={AddSchduleById}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/view-sessions"
              component={Sessions}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/edit-session/:id"
              component={EditSession}
              layout={TRAdminLayout}
            />

            <ProtectedRoute
              secret="PD"
              exact
              strict
              path="/add-course"
              component={AddCourse}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/view-courses"
              component={Courses}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/edit-course/:id"
              component={EditCourse}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/add-timings/:id"
              component={AddTimings}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/modify-trainee"
              component={ModifyTrainee}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/modify-schedule"
              component={ModifySchedule}
              layout={TRAdminLayout}
            />

            <ProtectedRoute
              secret="PD"
              path="/add-schedule"
              component={AddSchedule}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/overall-report"
              component={OverallReport}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/session-feedback-report"
              component={SessionReport}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/session-feedback-course-report/:id"
              component={SessionFeedbackByCourseId}
              layout={TRAdminLayout}
            />

            <ProtectedRoute
              secret="PD"
              path="/overall-feedback-report/:id"
              component={OverallFeedbackReport}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/session-wise-feedback-report/:id/:course_name"
              component={SessionWiseFeedbackReport}
              layout={TRAdminLayout}
            />

            <ProtectedRoute
              secret="PD"
              path="/add-presentation"
              component={AddPresentations}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/add-presentations/:id"
              component={AddPresentationsBySessionId}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/view-presentations/:id"
              component={ViewPresentations}
              layout={TRAdminLayout}
            />
            <ProtectedRoute
              secret="PD"
              path="/session-consolidated-feedback-report/:id"
              component={ConsolidatedSessionFeedback}
              layout={TRAdminLayout}
            />

            {/* Training Feedback Routes  */}

            <AppRoute
              path="/trainee-login"
              component={TraineeLogin}
              layout={FeedbackLayout}
            />
            <FProtectedRoute
              path="/trainingnew/feedback"
              component={TrainingFeedbackHome}
              layout={FeedbackLayout}
            />

            <AppRoute
              path="/trainee-forgot-password"
              component={TraineeForgotPassword}
              layout={FeedbackLayout}
            />
            <FProtectedRoute
              path={"/feedbackMenu/sessionwise/:id"}
              component={SessionWiseFeedback}
              layout={FeedbackLayout}
            />
            <FProtectedRoute
              path={"/feedbackMenu/coursewise/:id"}
              component={CourseWiseFeedback}
              layout={FeedbackLayout}
            />
            <FProtectedRoute
              path={"/feedbackMenu/overall/:id"}
              component={OverallFeedback}
              layout={FeedbackLayout}
            />

            <ProtectedRoute
              secret="normal"
              path="/profile/:id"
              component={Profile}
              layout={App}
            />
            <ProtectedRoute
              secret="normal"
              path="/edit-profile/:id"
              component={EditProfile}
              layout={App}
            />
            {/* <ProtectedRoute secret="normal" path="/admin-profile/:id" component={AdminProfile} layout={App}/> */}
            {/* <ProtectedRoute path="/view-presentations/:id" component={ViewPresentations} layout={App}/> */}

            <Redirect from="/" to="/" />
          </Switch>

          {/* <Switch></Switch> */}
        </AuthProvider>
      </BrowserRouter>
    );
  }
}

export default Router;
